import { render, staticRenderFns } from "./TemplateCollection.vue?vue&type=template&id=1d6306fe&scoped=true&"
import script from "./TemplateCollection.vue?vue&type=script&lang=ts&"
export * from "./TemplateCollection.vue?vue&type=script&lang=ts&"
import style0 from "./TemplateCollection.vue?vue&type=style&index=0&id=1d6306fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6306fe",
  null
  
)

export default component.exports